export { default as List } from 'users/containers/UsersListContainer';
export { default as Form } from 'users/containers/UserFormContainer';



// WEBPACK FOOTER //
// src/modules/secured/modules/users/containers/index.js